import {defineComponent, PropType, watch} from "vue";
import {useDefaultSlot} from "../util";

export default defineComponent({
  name: "ScDrag",
  props: {
    format: {
      type: String,
      default: "text/plain",
    },
    data: {
      type: String,
      default: "",
    },
    img: {
      type: Object as PropType<{ el: Element; x?: number; y?: number }>,
    },
  },
  setup(props, context) {
    const { el, getRenderFn } = useDefaultSlot(context.slots);
    const listener = (ev: DragEvent) => {
      if (ev.dataTransfer) {
        ev.dataTransfer.setData(props.format, props.data);
        if (props.img) {
          ev.dataTransfer.setDragImage(
            props.img.el,
            props.img.x || 0,
            props.img.y || 0
          );
        }
      }
    };
    watch(el, (el, preEl) => {
      if (preEl) {
        preEl.draggable = false;
        preEl.removeEventListener("dragstart", listener);
      }
      if (el) {
        el.draggable = true;
        el.addEventListener("dragstart", listener);
      }
    });
    return getRenderFn();
  },
});
